var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgConfluence = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7428 20.6177C6.52658 20.942 6.31035 21.3475 6.09412 21.6448C5.90493 21.9421 6.01304 22.3205 6.31035 22.5097L10.4457 25.0503C10.743 25.2395 11.1484 25.1314 11.3106 24.8341C11.4727 24.5638 11.689 24.1854 11.9322 23.807C13.5809 21.1042 15.2026 21.4286 18.1757 22.861L22.284 24.8071C22.6084 24.9693 22.9868 24.8341 23.1219 24.5098C23.1219 24.5098 23.1219 24.5098 23.1219 24.4827L25.095 20.0231C25.2301 19.6987 25.095 19.3474 24.7706 19.1852C23.9057 18.7798 22.1759 17.9689 20.6353 17.2121C15.0945 14.5634 10.3646 14.7256 6.7428 20.6177Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2572 10.5357C25.4734 10.2114 25.6896 9.80598 25.9058 9.50867C26.095 9.21136 25.9869 8.83296 25.6896 8.64376L21.5543 6.10311C21.257 5.91391 20.8786 5.995 20.6624 6.26528L20.6353 6.29231C20.4732 6.56259 20.2569 6.94099 20.0137 7.31938C18.365 10.0222 16.7433 9.69787 13.7702 8.26537L9.68889 6.31934C9.36455 6.15717 8.98615 6.29231 8.85101 6.61665C8.85101 6.61665 8.85101 6.61665 8.85101 6.64368L6.87795 11.1033C6.74281 11.4277 6.87795 11.779 7.20229 11.9412C8.06719 12.3466 9.797 13.1575 11.3376 13.9143C16.9054 16.5901 21.6354 16.4009 25.2572 10.5357Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 24.9984,
    y1: 26.3859,
    x2: 12.5011,
    y2: 19.2046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 7.01155,
    y1: 4.76948,
    x2: 19.5121,
    y2: 11.9539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgConfluence);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Confluence.0fa5519cf2afa446cc24142043e8293f.svg";